import MainLayout from "@/components/layout/MainLayout";
import PageHeader from "@/components/layout/PageHeader";
import { HelpCircle, MessageCircle, Mail, FileText } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const HelpPage = () => {
  return (
    <MainLayout>
      <div className="flex flex-col h-full">
        <PageHeader
          title="Help & Support"
          description="Get help and find answers to common questions"
          icon={HelpCircle}
        />

        <div className="flex-1 overflow-auto">
          <div className="container mx-auto px-6 py-8 max-w-4xl">
            <div className="grid gap-6 md:grid-cols-2">
              {/* Contact Support */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <MessageCircle className="h-5 w-5" />
                    Contact Support
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-sm text-gray-600">
                    Need help? Our support team is here to assist you.
                  </p>
                  <Button className="w-full">
                    <Mail className="mr-2 h-4 w-4" />
                    Email Support
                  </Button>
                </CardContent>
              </Card>

              {/* Documentation */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <FileText className="h-5 w-5" />
                    Documentation
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-sm text-gray-600">
                    Learn how to make the most of your AI agents and assistants.
                  </p>
                  <Button variant="outline" className="w-full">
                    View Documentation
                  </Button>
                </CardContent>
              </Card>
            </div>

            {/* Quick Links */}
            <div className="mt-8">
              <h2 className="text-lg font-semibold mb-4">Quick Links</h2>
              <div className="space-y-2">
                <a
                  href="#"
                  className="block p-3 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <h3 className="font-medium">Getting Started Guide</h3>
                  <p className="text-sm text-gray-600">
                    Learn the basics of creating and managing AI agents
                  </p>
                </a>
                <a
                  href="#"
                  className="block p-3 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <h3 className="font-medium">AI Assistant Templates</h3>
                  <p className="text-sm text-gray-600">
                    Explore pre-built assistants for common tasks
                  </p>
                </a>
                <a
                  href="#"
                  className="block p-3 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <h3 className="font-medium">Knowledge Base Management</h3>
                  <p className="text-sm text-gray-600">
                    Tips for organizing and maintaining your knowledge base
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HelpPage;
